import React from 'react'
import {
  faPollH,
  faFileAlt,
  faPaperclip,
  faPhotoVideo,
  faQuestion,
  faBallotCheck,
  faCogs,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import VideoConference from 'assets/icons/VideoConference'
import { BlockTypes } from 'enum/block-type.enum'

const fontAwesomeIcons = {
  [BlockTypes.BlockSurvey]: faPollH,
  [BlockTypes.BlockRichText]: faFileAlt,
  [BlockTypes.BlockTask]: faPaperclip,
  [BlockTypes.BlockMultimedia]: faPhotoVideo,
  [BlockTypes.BlockScorm]: faCogs,
  [BlockTypes.BlockEvaluation]: faBallotCheck,
}

const otherIcons: Record<
  Exclude<BlockTypes, keyof typeof fontAwesomeIcons>,
  React.ReactNode
> = {
  [BlockTypes.BlockMeeting]: <VideoConference color="#80808080" />,
}

interface BlockIconProps {
  type?: BlockTypes | null
  className?: string
}

export const BlockIcon = ({ type, ...rest }: BlockIconProps) => {
  if (!type) return <FontAwesomeIcon icon={faQuestion} {...rest} />
  const fontAwesomeIcon = fontAwesomeIcons[type]
  if (fontAwesomeIcon)
    return <FontAwesomeIcon icon={fontAwesomeIcon} {...rest} />
  return otherIcons[type] || null
}
